module.exports = require("./ar-IQ.d.ts");